import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { CvConfigurationService } from '../services/cv-configuration.service';
import { FilterTextPipe } from '../pipes/filter-text.pipe';

@Component({
    selector: 'cv-single-select',
    templateUrl: './single-select.component.html',
    styleUrls: ['./single-select.component.scss']
})
export class SingleSelectComponent implements OnInit {
    @Input() id: string;
    @Input() disabled = false;
    @Input() search = true;
    @Input() placeholder = undefined;
    @Input() value: any;
    @Input() options: any[];
    @Input() autoWidth = false;
    @Input() isLoading = false;
    @Input() primaryKey: string;
    @Input() label: string;
    @Input() selectionText: string;

    @Output() opened = new EventEmitter<void>();
    @Output() closed = new EventEmitter<void>();
    @Output() valueChange = new EventEmitter<any>();

    @ViewChild(MatSelect) matSelectComponent: MatSelect;

    @ViewChildren(CdkVirtualScrollViewport) cdkVirtualScrollViewPorts: QueryList<CdkVirtualScrollViewport>;

    filterText = '';

    constructor(
        public config: CvConfigurationService,
        private filterTextPipe : FilterTextPipe
    ) { }

    ngOnInit() {
    }

    closeDropdown() {
        this.matSelectComponent?.close();
    }

    onOpen() {
        // virtual scroll won't render properly without triggering a scroll to the top
        this.cdkVirtualScrollViewPorts?.forEach(viewport => {
            viewport.scrollToIndex(1);
            viewport.scrollToIndex(0);
            viewport.checkViewportSize();
        });

        this.opened.emit();
    }

    onClose() {
        const filteredOptions = this.filterTextPipe.transform(this.options, this.filterText, this.label);
        if (filteredOptions.length === 0) this.filterText = '';
        this.closed.emit();
    }

    onMatSelectChange(change: MatOptionSelectionChange) {
        if (!change.isUserInput)
            return;

        const id: number = change.source.value;
        this.value = id;
        this.valueChange.emit(this.value);
    }

}
